module.exports = __webpack_public_path__ + "img/图片1.9c7139ba.png";